import React from 'react';
import { TrendingUp, Users } from 'lucide-react';
import type { Game } from '../types';

interface TrendingGamesProps {
  games: Game[];
  onSelectGame: (gameId: number) => void;
}

export function TrendingGames({ games, onSelectGame }: TrendingGamesProps) {
  const trendingGames = games
    .filter(game => 
      game.playerCount >= 10000 && // Min 10k players
      game.monthlyStats?.[0]?.gainPercentage >= 10 // At least 10% growth
    )
    .sort((a, b) => 
      (b.monthlyStats?.[0]?.gainPercentage || 0) - (a.monthlyStats?.[0]?.gainPercentage || 0)
    )
    .slice(0, 5); // Show top 5 trending games

  if (trendingGames.length === 0) return null;

  return (
    <div className="mb-8">
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp className="w-5 h-5 text-emerald-600" />
        <h2 className="text-xl font-semibold text-gray-900">Trending Games</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        {trendingGames.map(game => (
          <div
            key={game.id}
            onClick={() => onSelectGame(game.id)}
            className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
          >
            <img
              src={game.imageUrl}
              alt={game.name}
              className="w-full h-32 object-cover"
            />
            <div className="p-4">
              <h3 className="font-bold text-gray-900 mb-2 line-clamp-1">{game.name}</h3>
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center text-gray-600">
                  <Users className="w-4 h-4 mr-1" />
                  <span>{game.playerCount.toLocaleString()}</span>
                </div>
                <div className="flex items-center text-emerald-600 font-medium">
                  <TrendingUp className="w-4 h-4 mr-1" />
                  <span>+{Math.round(game.monthlyStats?.[0]?.gainPercentage || 0)}%</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}